import { HomePage, TasksPage, ProfilePage, VideosPage, samplePage } from './pages';
import { withNavigationWatcher } from './contexts/navigation';

// import Video from './pages/Video/videos';
// import Video from './pages/Video/videos';
const routes = [
    {
        path: '/tasks',
        element: TasksPage
    },
    {
        path: '/profile',
        element: ProfilePage
    },
    {
        path: '/home',
        element: HomePage
    },
    {
        path: '/videos/:types',
        element: VideosPage
        
    }
   
];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
